<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="120px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.productLine')">
                  <el-select
                    v-model="formselect.productLine"
                    filterable
                    @change="resetCenter"
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.customerCenter')">
                  <el-select
                    v-model="formselect.customerCenterRegionId"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in center"
                      :value="item.id"
                      :label="item.center"
                      :key="'inx2' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

              <el-col :md="6" :sm="12" :xs="24" style="margin-top: 10px">
                <el-button type="primary" @click="getData" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="reset" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <!-- <el-button type="primary" icon="el-icon-download"
              >{{$t("button.exportReport")}}</el-button
            > -->

          <div class="KPIDiv">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <div class="block homeCon top">
                  <img src="~assets/img/icon_Shipped.png" />
                  <div
                    class="LeftB"
                    style="border: 0; display: inline-block; cursor: pointer"
                    @click="toDeviceDetail(1)"
                  >
                    <h4>{{ $t("desc.SendOutCount") }}</h4>
                    <span
                      >{{ KPIData.sendOutCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <img style="padding-left:140px" src="~assets/img/icon_Shipped.png" />
                  <div
                    class="LeftB"
                    style="border: 0; display: inline-block; cursor: pointer;"
                    @click="toDeviceRelieve"
                  >
                    <h4>{{ $t("desc.relieveBindCount") }}</h4>
                    <span
                      >{{ KPIData.relieveBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" class="leftDiv">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div class="LeftB" style="border-left-color: #28739a">
                        <h4>
                          {{ $t("desc.already_bind") }}
                          <el-button
                            class="fr moreBtn"
                            size="mini"
                            type="text"
                            @click="toInstallDashboard()"
                            ><i class="el-icon-pie-chart"></i
                          ></el-button>
                        </h4>
                        <span @click="toDeviceDetail(3)"
                          >{{ KPIData.bindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #51a470"
                        @click="toDeviceDetail(5)"
                      >
                        <h4>{{ $t("desc.Connected_Active") }}</h4>
                        <span
                          >{{ KPIData.onLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #cf554a"
                        @click="toDeviceDetail(4)"
                      >
                        <h4>{{ $t("desc.Connected_Offline") }}</h4>
                        <span
                          >{{ KPIData.offLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        style="border-left-color: #99a2ac"
                        @click="toDeviceDetail(2)"
                      >
                        <h4>{{ $t("desc.wait_bind") }}</h4>
                        <span
                          >{{ KPIData.waitBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <div class="divide"></div>
                <el-row :gutter="24">                  
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(20)"
                      >
                        <h4>{{ $t("desc.IntegratedGSNCount") }}</h4>
                        <span
                          >{{ KPIData.integratedGSNCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #99a2ac"
                        @click="toDeviceDetail(22)"
                      >
                        <h4>{{ $t("desc.IntegratedGSNWaitBindCount") }}</h4>
                        <span
                          >{{ KPIData.integratedGSNWaitBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(21)"
                      >
                        <h4>{{ $t("desc.IntegratedGSNBindCount") }}</h4>
                        <span
                          >{{ KPIData.integratedGSNBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #51a470"
                        @click="toDeviceDetail(24)"
                      >
                        <h4>{{ $t("desc.IntegratedGSNOnLineCount") }}</h4>
                        <span
                          >{{ KPIData.integratedGSNOnLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #cf554a"
                        @click="toDeviceDetail(23)"
                      >
                        <h4>{{ $t("desc.IntegratedGSNOffLineCount") }}</h4>
                        <span
                          >{{ KPIData.integratedGSNOffLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(15)"
                      >
                        <h4>{{ $t("desc.IndependentGSNCount") }}</h4>
                        <span
                          >{{ KPIData.independentGSNCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #99a2ac"
                        @click="toDeviceDetail(17)"
                      >
                        <h4>{{ $t("desc.IndependentGSNWaitBindCount") }}</h4>
                        <span
                          >{{ KPIData.independentGSNWaitBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(16)"
                      >
                        <h4>{{ $t("desc.IndependentGSNBindCount") }}</h4>
                        <span
                          >{{ KPIData.independentGSNBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #51a470"
                        @click="toDeviceDetail(19)"
                      >
                        <h4>{{ $t("desc.IndependentGSNOnLineCount") }}</h4>
                        <span
                          >{{ KPIData.independentGSNOnLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div> 
                      <div
                        class="LeftB"
                        style="border-left-color: #cf554a"
                        @click="toDeviceDetail(18)"
                      >
                        <h4>{{ $t("desc.IndependentGSNOffLineCount") }}</h4>
                        <span
                          >{{ KPIData.independentGSNOffLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" class="rightDiv">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(6)"
                      >
                        <h4>{{ $t("desc.RetroFit") }}</h4>
                        <span
                          >{{ KPIData.localInstallCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #99a2ac"
                        @click="toDeviceDetail(25)"
                      >
                        <h4>{{ $t("desc.RetroFitWaitBind") }}</h4>
                        <span
                          >{{KPIData.localInstallWaitBindCount}}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(8)"
                      >
                        <h4>{{ $t("desc.RetroFitBind") }}</h4>
                        <span
                          >{{ KPIData.localInstallBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #51a470"
                        @click="toDeviceDetail(13)"
                      >
                        <h4>{{ $t("desc.RetroFitOnLine") }}</h4>
                        <span
                          >{{ KPIData.localInstallOnLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #cf554a"
                        @click="toDeviceDetail(11)"
                      >
                        <h4>{{ $t("desc.RetroFitOffLine") }}</h4>
                        <span
                          >{{ KPIData.localInstallOffLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(7)"
                      >
                        <h4>{{ $t("desc.FactoryFit") }}</h4>
                        <span
                          >{{ KPIData.factoryInstallCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #99a2ac"
                        @click="toDeviceDetail(10)"
                      >
                        <h4>{{ $t("desc.FactoryFitWaitBind") }}</h4>
                        <span
                          >{{ KPIData.factoryInstallWaitBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #28739a"
                        @click="toDeviceDetail(9)"
                      >
                        <h4>{{ $t("desc.FactoryFitBind") }}</h4>
                        <span
                          >{{ KPIData.factoryInstallBindCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div class="divide"></div>
                      <div
                        class="LeftB"
                        style="border-left-color: #51a470"
                        @click="toDeviceDetail(14)"
                      >
                        <h4>{{ $t("desc.FactoryFitOnline") }}</h4>
                        <span
                          >{{ KPIData.factoryInstallOnLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                      <div
                        class="LeftB"
                        style="border-left-color: #cf554a"
                        @click="toDeviceDetail(12)"
                      >
                        <h4>{{ $t("desc.FactoryFitOffline") }}</h4>
                        <span
                          >{{ KPIData.factoryInstallOffLineCount
                          }}<small>{{ $t("desc.tai") }}</small></span
                        >
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { GetKPIStat, getCustomerRegionTable,getProductLines } from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      formselect: {
        customerRegionId: "",
        customerCenterRegionId: "",
      },
      KPIData: {},
      BlockH: {
        height: "",
        minHeight: "70px",
        // maxHeight:'100px',
      },
      allRegion: [],
      region: [],
      center: [],
      insight3_url: "",
      insight4_url: "",
      insight5_url: "",
      insight3_count: 0,
      insight4_count: 0,
      insight5_count: 0,
      productLineArr:[],
    };
  },

  async mounted() {
    this.insight4_url = Globals.Insight4_Url;
    this.insight3_url = Globals.Insight3_Url;
    this.insight5_url = Globals.Insight5_Url;
    this.insight4_count = Globals.Insight4_Count;
    this.insight3_count = Globals.Insight3_Count;
    this.insight5_count = Globals.Insight5_Count;
    await this.getProductLines()
    await this.getData();
    // this.getRegion();
  },
  methods: {
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
      this.$set(this.formselect, "productLine", "Other")
    },
    //获取地区
    getRegion() {
      var that = this;
      getCustomerRegionTable()
        .then((res) => {
          if (res.success) {
            var regionList = JSON.parse(JSON.stringify(res.result.centerList));
            var centerList = JSON.parse(JSON.stringify(res.result.centerList));
            that.allRegion = regionList;
            that.center = centerList;
            that.region = this.reduce(regionList);
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    changeRegion() {
      var that = this;
      var allRegionList = that.allRegion;
      var newCenter = [];
      if (
        that.formselect.customerRegionId != "" &&
        that.formselect.customerRegionId != null &&
        that.formselect.customerRegionId != "all"
      ) {
        allRegionList.forEach((o) => {
          if (o.parentId == that.formselect.customerRegionId) newCenter.push(o);
        });
        that.center = newCenter;
      } else {
        that.center = that.allRegion;
      }
    },
    async getData() {
      let that = this;
      if (this.formselect.customerRegionId == "all") {
        this.formselect.customerRegionId = "";
      }
      if (this.formselect.customerCenterRegionId == "all") {
        this.formselect.customerCenterRegionId = "";
      }
      let res = await GetKPIStat(
        that.formselect.customerRegionId,
        that.formselect.customerCenterRegionId,
        that.formselect.productLine
      );
      let data = res.result;
      this.KPIData = data;
    },
    toInstallDashboard() {
      this.$router.push({
        name: "/report/installDashboard",
      });
    },
    resetCenter() {
      this.$set(this.formselect, "customerCenterRegionId", "");
    },
    //数组对象去重
    reduce(config) {
      var hash = {};
      const newArr = config.reduceRight((item, next) => {
        hash[next.area] ? "" : (hash[next.area] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    reset() {
      this.formselect = {
        customerRegionId: "",
        customerCenterRegionId: "",
        productLine:"Other"
      };
      this.getData();
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    onSubmit() {},
    SetHeight() {
      var mHeight = window.innerHeight - 300; //总高
      this.BlockH.height = mHeight / 3 - 10 + "px";
    },

    toUseRate() {
      this.$router.push({
        name: "/report/utilizationStatistics",
      });
    },
    toMaintain(state) {
      this.$router.push({
        name: "/maintain/index",
        params: {
          gatewayState: state,
        },
      });
    },
    toAlarm(e) {
      this.$router.push({
        name: "/Alarm/AlarmList",
        params: {
          customerRegion: this.customerRegion,
          alarmStatus: "1",
          alarmType: e || "",
          isContainWJ: "false",
        },
      });
    },
    toDeviceRegi(gatewayState, gsnState, isContainWJ) {
      this.$router.push({
        name: "/device/register",
        params: {
          gatewayState: gatewayState,
          gsnState: gsnState,
          isContainWJ: isContainWJ,
        },
      });
    },
    toDeviceBind(gatewayState, isContainWJ) {
      this.$router.push({
        name: "/device/register",
        params: {
          gatewayState: gatewayState,
          isContainWJ: isContainWJ,
        },
      });
    },

    toDeviceDetail(type) {
      this.$router.push({
        path: "/report/deviceDetail",
        query: {
          bigRegionId: this.formselect.customerRegionId,
          customerCenterId: this.formselect.customerCenterRegionId,
          productLine: this.formselect.productLine,
          type: type,
        },
      });
    },
    toDeviceRelieve() {
      this.$router.push({
        name: "/report/relieveDevice",
        params:{
          productLine: this.formselect.productLine
        }
      });
    },

    toDeviceInstall(gatewayState, installMethod, gsnState) {
      this.$router.push({
        name: "/device/register",
        params: {
          installMethod: installMethod,
          gatewayState: gatewayState,
          gsnState: gsnState,
        },
      });
    },

    toInstallDashboard() {
      this.$router.replace("/report/installDashboard");
    },
  },
  created() {
    window.addEventListener("resize", this.SetHeight);
    var _self = this;
    this.$nextTick(() => {
      _self.SetHeight();
    });
  },
};
</script>
<style lang="less" scoped>
.theme1 {
 
  .leftDiv {
    padding-right: 20px !important;
    border-right: 1px solid #414248;
  }
  .rightDiv {
    padding-left: 20px !important;
    border-left: 1px solid #414248;
    margin-left: -1px;
  }
  .block {
    span {
      cursor: pointer;
    }
  }
}

@media (max-width: 991px) {
  .theme1 .leftDiv {
    padding-right: 10px !important;
  }
  .theme1 .rightDiv {
    padding-left: 10px !important;
    border-left: 0;
  }
}
</style>


